import { useEffect, useState } from 'react';
import { NavLink, Route, Routes, useNavigate } from 'react-router-dom';
import { useSesion } from '../contexto/Sesion.js';
import { ProveedorToast } from '../componentes/Toast.js';
import { api } from '../api/cliente.js';
import { Facturacion } from './Facturacion.js';
import { Facturas } from './Facturas.js';
import { ComprobantesMedicos } from './ComprobantesMedicos.js';
import { Tarifas } from './Tarifas.js';
import { Honorarios } from './Honorarios.js';
import { Solicitudes } from './Solicitudes.js';
import { Empresas } from './Empresas.js';
import { Medicos } from './Medicos.js';
import { Tramos } from './Tramos.js';
import { Estadisticas } from './Estadisticas.js';

const NAV = [
  { ruta: '/operador', etiqueta: '💵 Facturación', fin: true },
  { ruta: '/operador/facturas', etiqueta: '🧾 Facturas a empresas', fin: false },
  { ruta: '/operador/comprobantes', etiqueta: '📑 Comprobantes de médicos', fin: false },
  { ruta: '/operador/solicitudes', etiqueta: '📥 Solicitudes de Control', fin: false, contador: 'solicitudes' as const },
  { ruta: '/operador/empresas', etiqueta: '🏢 Empresas y Usuarios', fin: false },
  { ruta: '/operador/medicos', etiqueta: '🩺 Médicos', fin: false },
  { ruta: '/operador/tramos', etiqueta: '🛣️ Tramos de control', fin: false },
  { ruta: '/operador/tarifas', etiqueta: '🏷️ Tarifas a empresas', fin: false },
  { ruta: '/operador/honorarios', etiqueta: '💸 Honorarios médicos', fin: false },
  { ruta: '/operador/estadisticas', etiqueta: '📊 Estadísticas', fin: false },
];

const INTERVALO_SOLICITUDES_MS = 30_000;

export function OperadorApp() {
  const { operador, salir } = useSesion();
  const navegar = useNavigate();
  const [solicitudesPendientes, setSolicitudesPendientes] = useState(0);

  useEffect(() => {
    if (!operador) return;
    let vivo = true;
    async function consultar() {
      try {
        const solicitudes = await api.get<unknown[]>('/api/operador/solicitudes');
        if (vivo) setSolicitudesPendientes(solicitudes.length);
      } catch {
        // silencioso: el badge simplemente no se actualiza en este ciclo
      }
    }
    void consultar();
    const id = setInterval(consultar, INTERVALO_SOLICITUDES_MS);
    return () => { vivo = false; clearInterval(id); };
  }, [operador]);

  if (!operador) return null;
  return (
    <ProveedorToast>
      <div className="pagina-operador">
      <div className="cabecera-web">
        <div className="cabecera-web-interior">
          <div className="cabecera-logo">💰 Ausentia · Operador</div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <span className="muted">{operador.nombre}</span>
            <button className="fantasma" onClick={() => { salir(); navegar('/'); }}>Salir</button>
          </div>
        </div>
      </div>
      <div className="layout-operador">
        <nav className="nav-operador" aria-label="Secciones del panel">
          <div className="nav-operador-interior">
            {NAV.map((n) => (
              <NavLink
                key={n.ruta}
                to={n.ruta}
                end={n.fin}
                className={({ isActive }) => `nav-link ${isActive ? 'activo' : ''}`}
              >
                {n.etiqueta}
                {n.contador === 'solicitudes' && solicitudesPendientes > 0 && (
                  <span className="badge-contador">{solicitudesPendientes}</span>
                )}
              </NavLink>
            ))}
          </div>
        </nav>
        <div className="web">
          <Routes>
            <Route index element={<Facturacion />} />
            <Route path="facturas" element={<Facturas />} />
            <Route path="comprobantes" element={<ComprobantesMedicos />} />
            <Route path="solicitudes" element={<Solicitudes />} />
            <Route path="empresas" element={<Empresas />} />
            <Route path="medicos" element={<Medicos />} />
            <Route path="tramos" element={<Tramos />} />
            <Route path="tarifas" element={<Tarifas />} />
            <Route path="honorarios" element={<Honorarios />} />
            <Route path="estadisticas" element={<Estadisticas />} />
          </Routes>
        </div>
      </div>
      </div>
    </ProveedorToast>
  );
}
